module.exports = __webpack_public_path__ + "assets/img/wall-vacancies.6d66ed7d.svg";